<template>
    <div>
        <NavbarTwo />
        <PageTitle pageMainTitle="Cookie Policy" pageTitle="Cookie Policy" />
        <CookiePolicyContent />
    </div>
</template>

<script>
import NavbarTwo from '../Layout/NavbarTwoSafest'
import PageTitle from '../Common/PageTitle'
import CookiePolicyContent from '../Cookies/CookiePolicyContent'

export default {
    name: 'CookiePolicyPage',
    components: {
        NavbarTwo,
        PageTitle,
        CookiePolicyContent
    },
    mounted(){
        this.$metas( {
            title : 'Safest | Cookie Policy',
            description : 'Read all about our Cookie Policy.',
        } )
    }
}
</script>